// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1W8T1","title":"styles_title__3cDqu"};